import { render, staticRenderFns } from "./template3.vue?vue&type=template&id=91364b14&scoped=true"
import script from "./template3.vue?vue&type=script&lang=js"
export * from "./template3.vue?vue&type=script&lang=js"
import style0 from "./template3.vue?vue&type=style&index=0&id=91364b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91364b14",
  null
  
)

export default component.exports